type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface ToastMessage {
    id: string;
    type: ToastType;
    message: string;
}

type ToastCallback = (message: string, type: ToastType) => void;

class ToastService {
    private static instance: ToastService;
    private callbacks: ToastCallback[] = [];

    private constructor() {}

    public static getInstance(): ToastService {
        if (!ToastService.instance) {
            ToastService.instance = new ToastService();
        }
        return ToastService.instance;
    }

    public subscribe(callback: ToastCallback): () => void {
        this.callbacks.push(callback);
        return () => {
            this.callbacks = this.callbacks.filter(cb => cb !== callback);
        };
    }

    public show(message: string, type: ToastType = 'info'): void {
        this.callbacks.forEach(callback => callback(message, type));
    }
}

export const toastService = ToastService.getInstance();

// Hook React pour utiliser le service
export const useToast = () => {
    const showToast: ToastCallback = (message, type) => {
        toastService.show(message, type);
    };

    return { showToast };
};
